export default "__VITE_ASSET__j5Sm$Agc__"